module.exports = __webpack_public_path__ + "static/media/AC_PrimaryCenteredLogo.71020c10.png";